import React from "react";
import {useTranslate,Icon} from "./common.jsx";
export function FilterSidebar({a,options,filter,footer}){
 const t=useTranslate();
  const filterLabels = {encoding:"Encoding", writings:"Writing system", classes:"Classification", style:"Style", authors:"Designer", lari:"Lari symbol"};
  const abbreviations = {"Unicode (UTF-8)":"UNI", "Latin":"LAT", "STD8 (Geo, SP)":"SP", "Khutsuri Mtavruli":"Ⴀ", "Khutsuri Nuskhuri":"ⴀ", "Mkhedruli Mtavruli":"Ა", "Mkhedruli Nuskhuri":"ა"};
  const activeFilters = Object.entries(a.filters).flatMap(([key, values]) => (key === "lari" ? (values ? ["₾"] : []) : values || []).map(value => ({key, value, label:filterLabels[key] || key, short:abbreviations[value] || (value === "₾" ? value : t(value).split(/\s+/).map(word => [...word][0]).join('').slice(0,3).toUpperCase())})));
 return <>
      <div className="filter-rail" aria-label={t("Active filters", "აქტიური ფილტრები")}>
        <button className="sidebar-restore iconbutton" aria-label={t("Expand filters", "ფილტრების გაშლა")} aria-expanded={false} aria-controls="sidebar" onClick={() => {
          a.setSidebarCollapsed(false);
          requestAnimationFrame(() => document.querySelector('.sidebar-collapse')?.focus());
        }}><Icon name="expand" /></button>
        <div className="rail-divider" />
        <button className="rail-count" aria-label={t("Active filters", "აქტიური ფილტრები") + ': ' + activeFilters.length} onClick={() => a.setSidebarCollapsed(false)}>
          <Icon name="filter" /><b>{activeFilters.length}</b>
        </button>
        <div className="rail-selections">
          {activeFilters.map(({key, value, label, short}) => <button key={key + value} className="rail-selection" data-rail-filter={key} aria-label={t(label) + ': ' + t(value)} data-tooltip={t(label) + ': ' + t(value) + ' · ' + t("Click to edit", "შესაცვლელად დააწკაპუნეთ")} onClick={() => {
            a.setSidebarCollapsed(false);
            setTimeout(() => { const el = [...document.querySelectorAll('[data-filter], [data-select-filter], #larifilter')].find(el => (el.dataset.filter === key && el.value === value) || el.dataset.selectFilter === key || (key === 'lari' && el.id === 'larifilter')); el?.scrollIntoView({block:'nearest'}); el?.focus({preventScroll:true}); }, 280);
          }}><small>{t(label).slice(0,3)}</small><strong>{short}</strong></button>)}
        </div>
        {activeFilters.length > 0 && <button className="rail-clear iconbutton" aria-label={t("Reset all", "გასუფთავება")} onClick={() => a.setFilters({})}><Icon name="close" /></button>}
      </div>
      <aside
        id="sidebar"
        className={"sidebar " + (a.filtersOpen ? "open" : "")}
      >
        <div className="sidehead">
          <button className="sidebar-collapse iconbutton" aria-label={t("Collapse filters", "ფილტრების შეკეცვა")} aria-expanded={true} aria-controls="sidebar" onClick={() => {
            a.setSidebarCollapsed(true);
            requestAnimationFrame(() => document.querySelector('.sidebar-restore')?.focus());
          }}><Icon name="collapse" /></button>
          {t("Filters")}
          <button
            className="textbutton"
            onClick={() => {
              a.setFilters({});
              a.setQuery("");
            }}
          >
            {t("Reset all")}
          </button>
          <button
            className="mobilefilter"
            aria-label="Close filters"
            onClick={() => a.setFiltersOpen(false)}
          >
            <Icon name="close" />
          </button>
        </div>
        {[
          ["Encoding", "encoding"],
          ["Writing system", "writings"],
          ["Classification", "classes"],
        ].map(([label, k]) => (
          <section className="filtergroup" key={k}>
            <h3>{t(label)}</h3>
            {options(k).map(([v, n]) => (
              <label className="check" key={v}>
                <input
                  type="checkbox"
                  data-filter={k}
                  value={v}
                  checked={a.filters[k]?.includes(v) || false}
                  onChange={(e) => filter(k, v, e.target.checked)}
                />
                <span>{t(v)}</span>
                <small>{n}</small>
              </label>
            ))}
          </section>
        ))}
        {[
          ["Style", "style"],
          ["Designer", "authors"],
        ].map(([label, k]) => (
          <section className="filtergroup" key={k}>
            <h3>{t(label)}</h3>
            <select
              data-select-filter={k}
              aria-label={"Filter " + label.toLowerCase()}
              value={a.filters[k]?.[0] || ""}
              onChange={(e) =>
                a.setFilters({
                  ...a.filters,
                  [k]: e.target.value ? [e.target.value] : [],
                })
              }
            >
              <option value="">
                {t("All " + (k === "style" ? "styles" : "designers"))}
              </option>
              {options(k).map(([v]) => (
                <option key={v} value={v}>
                  {t(v)}
                </option>
              ))}
            </select>
          </section>
        ))}
        <label className="check">
          <input
            id="larifilter"
            type="checkbox"
            checked={!!a.filters.lari}
            onChange={(e) =>
              a.setFilters({ ...a.filters, lari: e.target.checked })
            }
          />
          {t("Includes lari symbol ₾")}
        </label>
        <p className="sidefoot">
          {footer}
        </p>
      </aside>
</>;
}
